import { render, staticRenderFns } from "./MealSelector.vue?vue&type=template&id=a6e3a848&scoped=true&"
import script from "./MealSelector.vue?vue&type=script&lang=js&"
export * from "./MealSelector.vue?vue&type=script&lang=js&"
import style0 from "./MealSelector.vue?vue&type=style&index=0&id=a6e3a848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e3a848",
  null
  
)

export default component.exports